"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColumnChart = void 0;
var React = _interopRequireWildcard(require("react"));
var _highcharts = _interopRequireDefault(require("highcharts"));
var _highchartsReactOfficial = _interopRequireDefault(require("highcharts-react-official"));
var _charts = require("../../../utils/charts");
var _classify = _interopRequireDefault(require("../../../utils/classify"));
var _ChartWrapper = require("../ChartWrapper");
var _ColumnChartModule = _interopRequireDefault(require("./ColumnChart.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ColumnChart = _ref => {
  let {
    isLoading,
    classNames,
    cardTitle,
    customExportOptions,
    series,
    drilldown,
    headerActions,
    hasEmptyData,
    emptyText,
    ...userOptions
  } = _ref;
  const chartRef = /*#__PURE__*/React.createRef();
  const columnChartSeries = series.map((seriesItem, index) => ({
    ...seriesItem,
    name: seriesItem.name,
    data: seriesItem.data,
    color: (0, _charts.getDataVizColor)(index),
    pointWidth: _charts.columnPlotWidth
  }));
  const addColorToDrilldownSeries = series => series?.map(seriesItem => ({
    ...seriesItem,
    // @ts-ignore - TS7006 - Parameter 'dataItem' implicitly has an 'any' type. | TS7006 - Parameter 'index' implicitly has an 'any' type.
    data: seriesItem.data.map((dataItem, index) => ({
      ...dataItem,
      color: (0, _charts.getDataVizColor)(index),
      pointWidth: _charts.columnPlotWidth
    }))
  }));
  const columnDrilldown = drilldown ? {
    ...drilldown,
    // @ts-ignore
    series: addColorToDrilldownSeries(drilldown.series),
    breadcrumbs: {
      floating: false
    }
  } : {};
  const defaultColumnChartOptions = (0, _charts.getColumnChartOptions)();
  const chartOptions = (0, _charts.mergeChartUserOptions)(defaultColumnChartOptions, {
    series: columnChartSeries,
    drilldown: columnDrilldown,
    ...userOptions
  });
  const {
    highChart,
    ...wrapperClassNames
  } = classNames || {};
  return /*#__PURE__*/React.createElement(_ChartWrapper.ChartWrapper, {
    isLoading: isLoading,
    title: cardTitle
    // @ts-ignore - TS2769 - No overload matches this call.
    ,
    ref: chartRef,
    classNames: wrapperClassNames,
    customExportOptions: customExportOptions,
    headerActions: headerActions,
    hasEmptyData: hasEmptyData,
    emptyText: emptyText
  }, /*#__PURE__*/React.createElement(_highchartsReactOfficial.default, {
    highcharts: _highcharts.default,
    containerProps: {
      className: (0, _classify.default)(_ColumnChartModule.default.columnChartContainer, highChart)
    }
    // @ts-ignore - TS2322 - Type 'RefObject<unknown>' is not assignable to type 'Ref<HighchartsReactRefObject> | undefined'.
    ,
    ref: chartRef,
    options: chartOptions
  }));
};
exports.ColumnChart = ColumnChart;